// 关于我们
const about = {
  'about.tab.title': '회사 소개',
  'about.welcome': 'QuickFox에 오신 것을 환영합니다,',
  'about.list.check': '업데이트 확인',
  'about.list.contact': '문의하기',
  'about.list.like': '좋은 평가 부탁드립니다',
  'about.list.terms': '서비스 약관',
  'about.list.policy': '개인정보 보호 정책',
  'about.list.vip': '회원 서비스 계약',
};
// 联系我们
const contact = {
  'contact.tab.title': '문의하기',
  'contact.title': '다음 방법으로 저희에게 연락하실 수 있습니다',
  'contact.list.offcial': '공식 웹사이트',
  'contact.list.wx': '위챗 공식 계정',
  'contact.list.qq': '고객 서비스 QQ',
  'contact.list.qqgroup': '공식 QQ 그룹',
  'contact.list.wxkf': '기술 지원 위챗',
  'contact.list.email': '이메일',
  'contact.list.op.visit': '방문하기',
  'contact.list.op.copy': '번호 복사',
  'contact.list.op.copyAccount': '계정 복사',
  'contact.list.op.copy.mail': '주소 복사',
  'contact.copy': '복사 성공',
};
// 帮助
const help = {
  'help.tab.title': '도움말',
  'help.title': '인간의 도움이 필요하세요? 온라인 고객 서비스에 문의하려면 클릭하세요',
  'help.contact': '지금 연락',
  'help.head.speedUp': '가속',
  'help.head.recharge': '충전',
  'help.head.other': '기타',
  'help.pv': '도움말 페이지 조회수',
  'help.speed': '가속',
  'help.other': '기타',
  'help.vip': '회원',
};
// 帮助详情
const helpDetail = {
  'helpDetail.tab.title': '상세 정보',
  'helpDetail.about': '관련 질문',
};

const notice = {
  'notice.tab.title': '메시지 센터',
  'notice.nodata': '아직 메시지가 없어요~',
  'notice.numberOfMsgJumpClick': '사이트 내 메시지 버튼에서 회원 페이지로의 클릭률',
  'notice.getItRightnow': '클릭하여 받기',
  'notice.allReadyGetIt': '수령 완료',
  'notice.getItSuccessfully': '수령 성공',
  'notice.rechargeNow': '즉시 충전',
};
// 技术支持
const tsupport = {
  'tsupport.title': '기술 지원',
  'tsupport.wechatDesc': 'QuickFox 기술 지원',
  'tsupport.addService': '지금 고객 서비스 추가',
  'tsupport.tip': '사용 중 충돌, 가속 불가, 지연 등 정상 사용에 영향을 미치는 문제가 발생하면 저희에게 연락해 주세요.',
  'tsupport.unSupport': '아직 지원되지 않음',
};
// Http
const http = {
  'http.prompt.networkError': '네트워크 오류',
};
const Welfare = {
  'welfare.header.todayincome': '오늘의 수익',
  'welfare.header.totalincome': '누적 수익',
  'welfare.coinsTasks': '골드 코인 임무',
  'welfare.tasksCard.chekout': '보기',
  'welfare.tasksCard.coins': '골드 코인',
  'welfare.tasks.invite': '초대 보상',
  'welfare.tasks.invite.unit': '골드 코인/인당',
  'welfare.tasks.invite.desc': '연간 멤버십 획득 초대',
  'welfare.tasks.invite.descript': '친구 초대하여 골드 코인 받기, 백만 홍빠 기다립니다',
  'welfare.tasks.sign': '매일 출석',
  'welfare.tasks.sign.descript': '매일 최대 50골드를 획득할 수 있어요',
  'welfare.tasks.wx': '공식 계정 팔로우',
  'welfare.tasks.bindEmail': '바인딩 보상',
  'welfare.tasks.bindText': '바인딩하기',
  'welfare.tasks.bindEmail.descript': '이메일 또는 전화번호를 바인딩하여 골드를 받으세요',
  'welfare.tasks.bindEmail.desc': '+6시간 VIP 기간',
  'welfare.tasks.bindEmail.bindTimes': '+6시간 VIP',
  'welfare.tasks.share': '공유하면 보상',
  'welfare.tasks.share.descript': '소셜 미디어에 포스터 공유 후 스크린샷 업로드하면 100코인 획득',
  'welfare.tasks.wx.descript': 'QuickFox 공식 WeChat 계정 팔로우 후 30코인 획득',
  'welfare.sign.dayno': '{day}일차',
  'welfare.sign.vipTime': '{vipTime}{vipTimeType}VIP',
  'welfare.sign.ticket': '50￥배송 쿠폰',
  'welfare.sign.day': '하루',
  'welfare.sign.hadSign': '연속 출석',
  'welfare.sign.sign': '출석',
  'welfare.sign.signed': '출석 완료',
  'welfare.sign.tips': '연속 출석하면 풍부한 보상을 받을 수 있어요~',
  'welfare.sign.successText': '출석 성공',
  'welfare.sign.rule.title': '체크인 규칙',
  'welfare.sign.rule.modalTitle': '체크인 규칙',
  'welfare.sign.rule.7day': '체크인 성공! {vipTime} {vipTimeType} VIP 기간을 얻었습니다.',
  'welfare.sign.rule.download': 'QuickFox 앱 다운로드',
  'welfare.sign.rule.downloadLast': '가속을 즐기실 수 있습니다. ',
  'welfare.sign.rule.yancaoRedpack': '500위안 이상 구매 시 50위안 할인 배송 쿠폰을 받았습니다',
  'welfare.sign.rule.eventTime': '이벤트 시간: 2024-12-24 12:00 ~ 2025-1-2 18:00',
  'welfare.sign.rule.part1': '{signCount} 연속 {signTimeType} 체크인마다 {rewardVipTime} {rewardTimeType} VIP 기간을 얻을 수 있습니다;',
  'welfare.sign.rule.part2': '{signCount} 연속 {signTimeType} 체크인마다 {rewardVipTime} {rewardTimeType} VIP 기간을 얻을 수 있습니다;',
  'welfare.sign.rule.part3': '체크인이 중단되면 일수 계산이 다시 시작됩니다;',
  'welfare.sign.rule.part4': '동일한 기기에서 여러 번 등록하면 체크인 보상이 기록되지 않으며 부적절한 방법으로 체크인 보상을 획득하는 것은 금지됩니다.',
  'welfare.sign.rule.interpretation': '퀵폭스 소유',
  'welfare.sign.successTips': '체크인 성공, {todayReward} 코인 획득. 매일 오는 거 잊지 마세요~',
  'welfare.sign.signSuccess': '성공',
  'welfare.sign.signSuccessVip': '체크인 성공, {vipTime}{timeType}VIP 시간이 당신의 것입니다, 매일 오는 것을 잊지 마세요~',
  'welfare.sign.ruleDetail': '매일 출석 체크하면 2코인을 얻을 수 있습니다. 연속 7일 출석 시 추가 보상이 주어집니다. 하루 최대 50코인까지 가능합니다. 매일 꼭 참여해 주세요!',
  'welfare.sign.ruleDetail2': '동일한 기기에서 여러 번 등록해도 코인 보상이 기록되지 않습니다. 부정한 방법으로 코인 보상을 얻는 것은 금지됩니다. QuickFox는 코인 보상을 회수하고 교환 주문을 종료할 권리가 있습니다.',
  'welfare.wx.follow': '공식 계정 팔로우',
  'welfare.wx.welfareForInvite': '초대 보상',
  'welfare.wx.signIn': '공유 보상',
  'welfare.wx.toSignIn': '체크인 하러 가기',
  'welfare.wx.toFollow': '팔로우 하러 가기',
  'welfare.wx.toInvite': '초대하기',
  'welfare.wx.toGet': '사용 가능',
  'welfare.wx.toGetHighest': '최대 보상',
  'welfare.wx.qrcodeTip.saved': 'QR 코드가 앨범에 저장되었습니다',
  'welfare.wx.qrcodeTip.failed': 'QR 코드 저장 실패',
  'welfare.wx.qrcodeTip.version': 'QR 코드를 저장하려면 최신 버전을 다운로드하세요!',
  'welfare.wx.Intro.title': '작업 소개',
  'welfare.wx.Intro.step': '단계',
  'welfare.wx.Intro.follow': '팔로우',
  'welfare.wx.Intro.reward': '보상',
  'welfare.wx.Intro.rewardText1.part1': '팔로우하면 얻을 수 있음',
  'welfare.wx.Intro.rewardText1.part2': '{vipCount}시간 VIP',
  'welfare.wx.Intro.pc.scanit': 'WeChat "스캔"을 사용하여 아래 이미지를 스캔하세요',
  'welfare.wx.Intro.mobile.scanit': '아래 QR 코드를 앨범에 저장하고 WeChat을 열어 "스캔"을 선택하여 스캔하세요',
  'welfare.wx.Intro.follow.descrip': '오른쪽 상단의 "팔로우" 버튼을 클릭하여 작업을 완료하세요',
  'welfare.invite.rule.title': '초대 규칙',
  'welfare.invite.personNum': '성공적으로 초대됨 (명)',
  'welfare.invite.viewDetail': '상세 보기',
  'welfare.invite.inviteDetail': '초대 상세',
  'welfare.invite.coinNum': '초대 보상 (코인)',
  'welfare.invite.dayNum': '초대 보상 (일)',
  'welfare.invite.duration': '증정 기간 (일)',
  'welfare.invite.toGoods': '코인 교환',
  'welfare.invite.rewardDetail': '보상 상세',
  'welfare.invite.face2face': '포스터 & 대면 초대 클릭',
  'welfare.invite.copyLink': '초대 링크 복사',
  'welfare.invite.post.saved': '포스터가 앨범에 저장되었습니다',
  'welfare.invite.post.failed': '포스터 저장 실패',
  'welfare.invite.post.descrip.tips': '포스터 또는 스크린샷을 저장하여 친구와 공유하고, 친구에게 QR 코드를 스캔하도록 초대하면, 초대가 성공하면 당신과 친구 각각 100골드를 받습니다',
  'welfare.invite.post.version': '포스터를 저장하려면 최신 버전을 다운로드해야 합니다!',
  'welfare.invite.post.pcAppTip': 'QuickFox 앱으로 이동하여 포스터를 저장하세요!',
  'welfare.invite.post.saveBtn': '포스터 저장',
  'welfare.invite.post.descrip.regist': 'QR 코드 스캔하여 등록QuickFox 계정, ',
  'welfare.invite.post.descrip.speedOnce': ' 앱 다운로드가속 사용, ',
  'welfare.invite.post.descrip.getCoins': ' 당신과 친구각각 100골드 획득, ',
  'welfare.invite.process.regist': ' 친구 클릭초대 링크로 등록, ',
  'welfare.invite.process.speedOnce': ' 앱 다운로드가속 사용 1회, ',
  'welfare.invite.process.getCoins': ' 당신과 친구각각 100골드 획득, ',
  'welfare.invite.process.tips': '* 친구는 새 모바일 기기(즉, 이전에 QuickFox 계정에 로그인하지 않은 휴대폰)에서 초대 링크에 등록된 계정으로 로그인하고, 가속을 한 번 사용해야 보상을 받을 수 있습니다.',
  'welfare.invite.link.title': ' 수퍼 VIP를 받을 수 있습니다',
  'welfare.invite.link.descrip': ' QuickFox 가속기에서 혜택을 제공합니다.등록하면 수퍼 VIP를 받을 수 있으며, 현금 빨간 봉투가 당신을 기다립니다!',
  'welfare.invite.historyBtn': ' 초대 세부 정보',
};
const PageTitle = {
  'pageTitle.goods': ' 쇼핑몰',
  'pageTitle.welfare': ' 혜택',
  'pageTitle.invite.detail': ' 초대 상세 정보',
  'pageTitle.taskDetails': ' 공식 계정 팔로우',
  'pageTitle.inviteDetails': ' 초대하고 보상 받기',
  'pageTitle.taskSignin': ' 매일 체크인',
  'pageTitle.taskCenter': ' 태스크 센터',
  'pageTitle.taskEmail': ' 이메일 바인딩',
  'pageTitle.taskShare': ' 보상 공유',
  'pageTitle.appApplyRecord': '신청 기록',
};
const Common = {
  'common.ok': ' 확인',
  'common.confirm': ' 확인',
  'common.cancel': ' 취소',
  'common.avatar': ' 아바타',
  'common.iSee': ' 알겠습니다',
  'common.human': ' 사람',
  'common.requreUpdate': ' 현재 버전이 너무 오래되었습니다.최신 버전으로 업데이트하세요.',
  'common.currency.dollar': ' 달러',
  'common.free': ' 무료',
  'common.currency.rmb': ' 위안',
  'common.init': ' 프로젝트 초기화 중',
  'common.payType.offline': ' 오프라인 결제',
  'common.payType.alipay': ' 알리페이',
  'common.payType.wxMiniProg': ' 위챗 미니 프로그램',
  'common.payType.wx': ' 위챗',
  'common.payType.bank': '은행 카드/신용 카드',
  'common.selectPlaceholder': '선택되지 않음',
  'common.loading': '로드 중',
  'common.noMore': '더 이상 없음'
};
const Tips = {
  'tips.pleaselogin': '먼저 로그인해 주세요',
  'tips.pleaselogin.event': '로그인 후에 이벤트에 참여할 수 있어요~',
  'tips.gologin': '로그인하러 가기',
  'tips.loadFailed': '로딩 실패',
  'tips.listLoadFailed': '목록 로드 실패',
  'tips.loadFailed.retry': '로드 실패, 나중에 다시 시도해 주세요',
  'tips.refreshed': '새로 고침 완료',
  'tips.refreshFailed': '새로 고침 오류',
  'tips.saving': '저장 중...',
  'tips.saveQrcode': 'QR 코드 저장',
  'tips.copyed': '복사 성공',
  'tips.loadingHard': '필사적으로 로딩 중, 잠시 기다려 주세요...',
  'tips.loading': '로딩 중...',
  'tips.nodata.forNow': '데이터 없음',
  'tips.load.success': '로딩 완료',
  'tips.goingToPay': '결제로 이동 중...',
  'tips.cancelSuccessful': '취소 성공',
  'tips.failToRefreshOrder': '주문 새로 고침 실패',
  'tips.refreshOrderError': '주문 새로 고침 오류',
  'tips.refreshListError': '목록 새로 고침 오류',
  'tips.refreshListDone': '목록 새로 고침 완료',
  'tips.pull2Refresh': '아래로 당겨서 새로 고침',
  'tips.release2Refresh': '새로 고침을 위해 놓기',
  'tips.refreshing': '새로 고침 중',
};
// 开通记录
const ActivationRecord = {
  'record.records': '활성화 기록',
  'record.options': '작업',
  'record.memberRefund': '회원 환불',
  'record.syncOrder': '주문 동기화',
  'record.tip': '친절한 알림',
  'record.tipDesc': 'QuickFox 슈퍼 VIP 월간 구독 서비스를 취소하시겠습니까? 이로 인해 계정 갱신이 중지되며, 만료 시 VIP 전용 라우트 사용이 불가능해집니다.',
  'record.memberPage.pageViewsOfActivationRecord': '회원 페이지 - 구독 기록 페이지 조회수',
  'record.refundFail.tryAgain': '환불 요청 실패, 나중에 다시 시도해 주세요.',
  'record.cancel': '취소',
  'record.noRecordYet.goAndActive': '아직 기록이 없어요, 서둘러 회원 가입하세요~',
  'record.chooseRefundOrder': '환불 주문 선택',
  'record.weSupportRefund.oneUserHasOneService': '슈퍼 VIP 멤버십 구매 후 7일 이내에 환불을 요청할 수 있습니다. 환불할 주문을 선택하시면 자금은 원래 결제 방법으로 반환됩니다. 각 사용자는 환불 서비스를 한 번만 이용할 수 있습니다.',
  'record.failToGetList': '목록 가져오기 실패',
  'record.failToGetActivationList': '활성화 기록 목록 가져오기 실패',
  'record.failToGetRefund': '환불 상태 가져오기 실패',
  'record.getListFail': '목록 가져오기 실패',
  'record.recordItem.numberOfRefund': '멤버십 페이지 - 구독 기록, 주문 카드의 환불 버튼 클릭 수',
  'record.recordItem.getTime': '획득 시간',
  'record.recordItem.refundTime': '환불 시간',
  'record.recordItem.refuseRefund': '환불 불가',
  'record.recordItem.refundComplete': '환불 완료',
  'record.recordItem.addDay': '혜택 기간',
  'record.recordItem.handsel': '선물',
  'record.recordItem.orderNumber': '주문 번호',
  'record.recordItem.orderType': '결제 방법',
  'record.recordItem.orderNumberHasBeenCopied': '주문 번호 복사됨',
  'record.recordItem.refund': '환불',
  'record.recordItem.outActivity': '외부 활동',
  'record.resaonModal.refundReason': '환불 사유',
  'record.resaonModal.supplement': '추가 설명',
  'record.resaonModal.refundReasonPlaceholder': '선택 사항입니다. 환불이 필요한 이유를 알려주시면 최대한 빨리 최적화할 수 있습니다. 최대 50자 입력 가능합니다.',
  'record.resaonModal.reasonLimitedText': '최대 50자만 입력할 수 있습니다.',
  'record.resaonModal.failToSubmitRefundRequset': '환불 요청 제출에 실패했습니다.',
  'record.resaonModal.refundApplication': '환불 요청',
  'record.reasonModal.failToRefund': '작업 실패',
  'record.reasonModal.successfulRefund': '작업 성공',
  'record.reasonModal.weSupportRefund.reviewDetailonITunes': '슈퍼 VIP 멤버십 구매 후 7일 이내에 환불 요청을 지원합니다. iTunes에서 주문을 확인하고 환불 요청을 제출하십시오.',
  'record.reasonModal.numberOfConfirmRefund': '멤버십 페이지 - 활성화 기록 페이지, 환불 버튼 클릭 수 확인',
  'record.reasonModal.ok': '알겠습니다',
};
// 时间类型(通用)
const TimeType = {
  // 时间类型(通用)
  'timeType.day': '일',
  'timeType.week': '주',
  'timeType.month': '월',
  'timeType.season': '계절',
  'timeType.year': '년',
  'timeType.minute': '분',
  'timeType.hour': '시간',
  'timeType.sentence': '{day} 일 {hour} 시간 {minute} 분 {second} 초',
};
// 防锁定教程
const tutorial = {
  'tutorial.mi': '샤오미 휴대폰 튜토리얼',
  'tutorial.vivo': '비보 휴대폰 튜토리얼',
  'tutorial.oppo': '오포 휴대폰 튜토리얼',
  'tutorial.huawei': '화웨이 휴대폰 튜토리얼',
  'tutorial.honor': '아너 휴대폰 튜토리얼',
  'tutorial.oneplus': '원플러스 휴대폰 튜토리얼',
  'tutorial.samsung': '삼성 휴대폰 튜토리얼',
  'tutorial.general': '기타 휴대폰 튜토리얼',
  'tutorial.tips': '휴대폰 브랜드를 선택하여 해당 튜토리얼을 확인하세요',
  'tutorial.title': '속도 향상 및 연결 끊김 방지 튜토리얼',
  'tutorial.purchase.title': '슈퍼 VIP 구매',
  'tutorial.purchase.content0': 'Google Play 결제로 멤버십 구매 시 결제가 완료되지 않으면 다음 방법을 시도해 볼 수 있습니다:',
  'tutorial.purchase.title1': '1. 공식 웹사이트에서 멤버십 구매',
  'tutorial.purchase.content1': '아래 버튼을 클릭하여 공식 웹사이트에서 멤버십을 구매할 수 있으며, WeChat/Alipay/PayPal 등 다양한 결제 방법을 지원하며 가격이 더 저렴합니다;',
  'tutorial.purchase.title2': '2. QuickFox 최신 버전 설치',
  'tutorial.purchase.content2': 'QuickFox 공식 웹사이트에서 최신 버전을 다운로드할 수 있으며, WeChat/Alipay/PayPal 등 다양한 결제 방법을 지원합니다;',
  'tutorial.purchase.title3': '3. 고객 서비스에 문의하여 구매',
  'tutorial.purchase.content3': 'QuickFox는 WeChat/Alipay/은행을 통해 QR 코드 스캔 또는 송금으로 Super VIP를 구매할 수 있습니다. 앱 왼쪽 상단을 클릭하여 고객 서비스에 문의하거나 공식 WeChat 계정 QuickFox2020을 추가하여 문의할 수 있습니다.',
  'tutorial.purchase.button': '공식 웹사이트에서 구매하세요',
  'tutorial.purchase.button1': '최신 버전 다운로드',
};
// 邀请裂变1, 2期活动结束
const pointEventEnd = {
  'pointEventEnd.tooltipText': '안타깝게도 이벤트가 종료되었습니다',
  'pointEventEnd.invitationWithPrize': '초대하고 보상 받기',
  'pointEventEnd.scanQRToFollow': 'QR 코드를 스캔하여 공식 계정을 팔로우하고 다음에 봐요~',
  'pointEventEnd.scanQRToFollowForMoreInfo': 'QuickFox 공식 계정을 팔로우하여 더 많은 흥미로운 이벤트 소식을 받아보세요.',
  'pointEventEnd.copyOfficialAccount': '공식 계정 복사',
};
// 邀请裂变第3期
const taskCenterV3 = {
  'task.mission.pv': '작업 센터 페이지 조회수',
  'task.lookforwardForMoreTasks': '더 많은 작업이 곧 제공될 예정입니다',
  'task.taskCard.isPcAppNotice': '초대 작업은 현재 모바일에서만 지원됩니다. QR 코드를 스캔하여 QuickFox 앱을 다운로드하고 작업을 완료하세요.',
  'task.taskCard.numberOfInvitationClick': '초대 작업 클릭 수',
  'task.taskCard.numberOfFollowTaskClick': '공식 계정 작업 클릭 수',
  'task.taskCard.numberOfCheckInClick': '복지 페이지, 체크인 작업 클릭 수',
  'task.detail.follow.numberOfFollowPage': '공식 계정 작업 페이지 조회수',
  'task.invite.invitePagePv': '초대 작업 페이지 조회수',
  'task.invite.cpoyPv': '초대 링크 복사 클릭 수',
  'task.invite.loadingText': '아직 기록이 없어요, 친구를 초대하세요~',
  'task.invite.nodataText': '아직 기록이 없어요, 빨리 임무를 완료하고 코인을 얻으세요~',
  'task.invite.noContentText': '아직 기록 없음',
  'task.invite.noContentTextPart1': '빨리 친구를 초대하세요',
  'task.invite.coinDetail': '코인 상세 내역',
  'task.invite.coinDetailPv': '코인 상세 내역 조회수',
  'task.invite.numberOfClickInviteBtn': '초대 버튼 클릭 수',
  'task.invite.posterAndFace2Face': '포스터 & 대면 초대',
  'task.invite.inviteForNow': '지금 초대하기',
  'task.invite.linkCopied': '링크 복사됨',
  'task.invite.posterLoading': '포스터 로딩 중...',
  'task.invite.descript.title.part1': '친구 한 명을 초대할 때마다 최대',
  'task.invite.descript.title.part2': '지금 초대하러 가세요',
  'task.invite.reward.descrip': '보상',
  'task.invite.reward.descrip.part1': '1. 초대받은 친구가 모바일 단말기에서 가속을 한 번 사용하면, 초대받은 친구는 30분 VIP 시간 보상을 받을 수 있습니다.',
  'task.invite.reward.descrip.part2': '2. 초대한 친구가 VIP 구매를 완료하면, 친구의 구매 기간의 10%를 추천 보상으로 받게 됩니다.',
  'task.invite.reward.descrip.part3': '3. 부정한 방법으로 대량 등록하는 경우 위반으로 간주되어 초대 보상을 받을 수 없습니다.',
  'task.invite.reward.descrip.part4': '4. 친구가 환불하면 해당 초대 보상이 취소됩니다.',
  'task.invite.reward.descrip.part5': '2. 초대한 친구가 VIP 구매를 완료하면, 구매 기간의 10% + 5%를 보상으로 받습니다.',
  'task.invite.details.tab.waitingData': '가속 대기 중',
  'task.invite.details.tab.waitingToGiveData': '배포 대기 중',
  'task.invite.details.tab.completedData': '완료됨',
  'task.invite.details.tab.inValidData': '만료됨',
  'task.invite.details.tab.closed': '닫힘',
  'task.invite.details.tab.toAppeal': '항의 대기 중',
  'task.invite.details.tab.toPaid': '결제 대기',
  'task.invite.details.tab.violationData': '규정 위반 사용자',
  'task.invite.details.content.type1': '친구가 등록을 완료했습니다. 친구에게 새 기기에서 앱을 다운로드하고 계정을 사용하여 속도 향상을 요청하세요. 보상은 1시간 이내에 도착합니다.',
  'task.invite.details.content.type2': '친구 초대가 성공적으로 완료되어 30분 VIP 시간 보상이 지급되었습니다.',
  'task.invite.details.content.type3': '아이고, 이 친구는 새 기기에서 첫 번째 속도 향상을 수행하지 않았습니다. 이 초대는 실패했습니다~',
  'task.invite.details.content.type4': '친구 초대가 성공적으로 완료되어 시스템 위험 검토가 진행 중입니다. 친구의 30분 VIP 시간 보상은 1시간 이내에 계정에 적립됩니다.',
  'task.invite.details.content.type5': '이 친구는 규정을 위반하여 보상을 지급할 수 없습니다',
  'task.invite.details.loading': '초대 내역을 불러오는 중...',
  'task.invite.details.load.faild': '초대 내역 불러오기 실패',
  'task.signin.viewPv': '복지 - 체크인 페이지, 페이지 뷰',
  'task.signin.walfare': '신규 사용자 체크인 혜택',
  'task.signin.walfare.detail': '친구 초대로 등록 후 7일 이내에 3일 연속 체크인하면 추가로 100골드를 받을 수 있습니다. 초대 캠페인에 참여하여 친구를 초대해 함께 체크인하면 동일한 체크인 골드 보상을 받을 수 있습니다.',
  'task.signin.walfare.downloadForSignin': 'QuickFox 앱 다운로드 후 친구 초대하여 체크인',
  'task.signin.walfare.goToInviteWithPhone': '모바일에서 초대하기',
  'task.signin.walfare.goToInvite': '초대하기 >',
  'task.signin.walfare.numberOfCheckInClick': '혜택 - 체크인 작업 페이지, 체크인 클릭',
  'task.signin.walfare.signing': '체크인 데이터 로드 중, 잠시 기다려 주세요...',
  'task.signin.walfare.signSuccessTipsPart1': '체크인 성공, {todayReward}골드 코인 획득, ',
  'task.signin.walfare.signSuccessTipsPart2': '신규 사용자로 연속 출석 혜택을 받으셨습니다. 추가로 100코인을 드립니다~',
  'task.signin.walfare.signSuccessTipsPart3': '매일 오는 것을 잊지 마세요~',
  'task.goods.detail.title': '상품 상세 정보',
  'task.goods.detail.lessCoin': '코인 부족',
  'task.goods.detail.lessCoinTips': '코인이 부족합니다. 더 많은 코인을 얻기 위해 임무를 완료하세요~',
  'task.goods.detail.lessCoinTips.goForMoreCoin': '코인이 부족합니다. 더 많은 코인을 얻기 위해 임무를 완료하세요~iOS 기기는 현재 차액 충전을 지원하지 않습니다.다른 시스템 기기에서 교환을 진행해 주세요',
  'task.goods.detail.exchangeRes.goCheck': ' 성공적으로 교환되었습니다. "교환 기록" 페이지에서 상품을 확인하고 수령할 수 있습니다.',
  'task.goods.detail.exchange': ' 상품 교환',
  'task.goods.detail.exchangeSuccessful': ' 교환 성공',
  'task.goods.detail.exchangeSuccessful.congratulate': ' 축하합니다.성공적으로 교환하셨습니다.다음 방법으로 상품을 받으실 수 있습니다~',
  'task.goods.detail.exchangeSuccessful.tips': ' 축하합니다.교환 신청이 성공적으로 완료되었습니다. 2영업일 이내에 검토를 완료할 예정이며, "교환 기록" 페이지에서 진행 상황을 확인할 수 있습니다~',
  'task.goods.detail.exchangeSuccessful.getVip': ' 교환 성공, 슈퍼 VIP 특권이 귀하의 계정에 충전되었습니다.',
  'task.goods.detail.exchange.fail.retry': ' 교환 실패, 나중에 다시 시도해 주세요',
  'task.goods.detail.exchangeConfirm': ' 이 상품을 교환하시겠습니까 ? ',
  'task.goods.detail.stock.less': ' 재고 부족',
  'task.goods.detail.stock.less.tips': ' 이 상품은 재고가 부족하여 일시적으로 교환할 수 없어요~',
  'task.goods.detail.signinDay.less': ' 체크인 일수 부족',
  'task.goods.detail.signinDay.less.tips': ' 이 상품은 { day }회 이상 체크인해야 교환할 수 있어요, 빨리 체크인하세요~',
  'task.goods.detail.remain': ' 남은',
  'task.goods.detail.tillNext': ' 다음 플래시 세일까지',
  'task.goods.blockTitle': ' 제품 소개',
  'task.goods.noStock': ' 재고 없음',
  'task.goods.noConvertible': ' 교환 불가',
  'task.goods.overConvertibleLimit': ' 교환 한도 도달',
  'task.goods.exchange.now': ' 지금 교환하기',
  'task.goods.order.total': ' 주문 총액',
  'task.goods.coinForPay': ' 코인으로 결제',
  'task.goods.require.diff': ' 가격 차액 필요',
  'task.goods.pay.diff': ' 차액 지불',
  'task.goods.pay.diff.exchange': ' 차액 지불 후 교환',
  'task.goods.pay.way': ' 결제 방법 선택',
  'task.goods.contact.offcialAccount': ' QuickFox 위챗 고객 서비스 { number }에 문의',
  'task.goods.offcialAccount.copy': ' (위챗 ID 복사하기) ',
  'task.goods.contact.customerService': ' QuickFox 위챗 고객 서비스에 문의',
  'task.goods.go': ' 지금 이동',
  'task.point.detail.coinType0': ' 코인 추첨',
  'task.point.detail.coinType1': ' 코인 교환',
  'task.point.detail.coinType2': ' 친구 { account } 초대하여 등록',
  'task.point.detail.coinType3': ' 친구 초대로 등록',
  'task.point.detail.coinType4': ' 상위 순위 사용자 플랫폼 보상',
  'task.point.detail.coinType5': ' 매일 출석',
  'task.point.detail.coinType6': ' 위챗 공식 계정 팔로우',
  'task.point.detail.coinType7': ' 몰 교환 주문 만료',
  'task.point.detail.coinType8': ' 골드 코인 복권 수익',
  'task.point.detail.coinType9': ' 3일 연속 출석 보너스',
  'task.point.detail.coinType10': ' 친구 3일 연속 출석 보너스',
  'task.point.detail.bindReward': ' 바인딩 선물',
  'task.point.detail.shareReward': ' 공유 작업 보상',
  'task.point.detail.coinType11': ' 추석 골드 코인 증정',
  'task.point.detail.coinType13': ' 골드 코인 만료',
  'task.point.detail.coinType16': ' 월드컵 예측 이벤트',
  'task.redeem.modal.title': ' 아직 지원되지 않음',
  'task.redeem.modal.content': ' iOS 기기는 현재 추가 결제 교환을 지원하지 않습니다.다른 시스템 기기에서 교환을 수행하십시오.',
  'task.redeem.exchangeRecordPv': ' 교환 기록 조회수',
  'task.redeem.exchangeRecord': ' 교환 기록',
  'task.redeem.exchangeCode': ' 교환 코드: ',
  'task.redeem.draw.link': ' 수령 링크: ',
  'task.redeem.draw.code': ' 상품 수령 코드: ',
  'task.redeem.exchangeCode.use': ' 교환 방법',
  'task.redeem.norecord.goForIt': ' 아직 기록이 없어요, 빨리 상품을 교환하세요~',
  'task.redeem.record.tips': ' QuickFox는 2영업일(월요일부터 금요일까지 영업일) 내에 배포를 완료할 예정입니다.배포 후 가능한 빨리 확인하여 사용하시기 바랍니다.',
  'task.redeem.clickForIt': ' 여기를 클릭하여 보기',
  'task.redeem.copy': ' 복사',
  'task.redeem.copied': ' 복사됨',
  'task.redeem.payForNow': ' 지금 결제',
  'task.redeem.orderWill': ' 주문은 { time }에 만료됩니다.제때 결제해 주세요.',
  'task.redeem.dataReady': ' 데이터 준비 중입니다.잠시 기다려주세요...',
  'task.redeem.drawed': ' 당첨',
  'task.redeem.receive': ' 지금 받기',
  'task.redeem.drawed.limitDate': ' 상품 유효 기간',
  'task.redeem.drawed.waitForit': ' { lotteryName } 당첨, 배송 대기 중(2영업일 이내 완료)',
  'task.redeem.drawed.waitForit.physical': ' { lotteryName } 당첨, 수령을 위해 WeChat 고객 서비스 chenhan_xy에 문의하세요',
  'task.redeem.drawed.violation': ' { lotteryName } 당첨, 위반으로 인해 주문이 취소되었습니다.',
  'task.redeem.drawed.success': ' { lotteryName } 당첨, 회원권이 귀하의 계정에 충전되었습니다.확인해 주세요.',
  'task.redeem.drawed.goods.success': ' { lotteryName } 당첨, 귀하의 계정에 충전되었습니다.확인해 주세요.',
  'task.redeem.drawed.goods.success.physical': ' { lotteryName } 당첨, 상품이 배송되었습니다.',
  'task.redeem.drawed.svip.success': ' 슈퍼 VIP 회원권이 귀하의 계정에 충전되었습니다.확인해 주세요.',
  'task.redeem.drawed.vip.success': ' VIP 회원권이 귀하의 계정에 충전되었습니다.확인해 주세요.',
  'task.redeem.drawed.violation.closed': ' 규정 위반으로 주문이 취소되었습니다',
  'task.redeem.violation.contact': ' 규정 위반으로 인한 코인 획득, 추첨 보상 지급 불가.문의사항은 info @quickfox.com.cn으로 이메일 보내주세요.',
  'task.redeem.limit.contact': ' 초대된 계정에 이상이 있어 교환이 일시적으로 제한됩니다.info@quickfox.com.cn으로 신청서를 보내주세요.QuickFox 계정과 최근 초대한 모든 친구와의 채팅 기록을 포함해야 합니다.',
  'task.redeem.order.fail': ' 이 주문은 만료되었으며, 사용된 코인은 계정으로 환불되었습니다.',
  'task.redeem.draw.customer.service': ' 상세 내용 확인 후 위챗 추가로 교환 완료하세요.',
  'task.redeem.drawLink.tips': ' 링크 수령: 배송 대기(2영업일 이내 완료)',
  'task.redeem.drawLink.limit.tips': ' 상품 코드는 { expireTime }에 만료됩니다.가능한 빨리 교환해 주세요.',
  'task.redeem.noname': ' 아직 이름 없음',
  'task.redeem.checkMethod': ' 교환 방법 보기',
  'task.redeem.invite.reward': '邀请有礼',
  'task.redeem.follow.reward': '关注公众号',
  'task.redeem.bind.reward': '绑定手机/邮箱',
  'task.redeem.signin.reward': '每日签到',
  'task.redeem.intlAuth.reward': '留学认证奖励',
  'task.redeem.coin.reward': '金币兑换',
  'task.redeem.game.reward': '小游戏奖励',

  'task.event.rule': ' 이벤트 규칙',

  'task.event.question': '자주 묻는 질문',
  'task.event.needToKnow': '이벤트 안내',
  'task.goods.loadGoods.fail': '상품 목록 로드 실패',
  'task.goods.coin.loadFailed': '골드 코인 로드 실패',
  'task.goods.shop.requreUpdate': '골드 코인 몰 접속 이상, 더 나은 사용자 경험을 위해 최신 클라이언트로 업그레이드해 주세요',
  'task.goods.coin.less.loadFailed': '남은 골드 코인 로드 오류',
  'task.goods.coin.balance': '골드 코인 잔액',
  'task.goods.coin.detail.view': '골드 코인 거래 내역 보기',
  'task.goods.coin.exchange.record': '쇼핑몰 교환 주문 보기',
  'task.lottery.detailPv': '추첨 상품 상세 페이지 조회수',
  'task.lottery.waitMsg': '추첨 중입니다, 조금만 기다려주세요, 곧 결과가 발표됩니다~',
  'task.lottery.drawOut': '상품이 모두 소진되었어요, 상품을 보충 중이니 나중에 다시 와주세요~',
  'task.lottery.networkErrMsg': '네트워크 오류가 발생했습니다, 네트워크를 확인하고 다시 시도해주세요~',
  'task.lottery.Replenishment': '상품이 모두 소진되었어요, 상품을 보충 중이니 나중에 다시 와주세요~',
  'task.lottery.balance.lessMsg': '골드 코인이 부족합니다. 빨리 골드 코인을 벌어보세요~',
  'task.lottery.forAWhile': '현재 추첨을 할 수 없습니다. 나중에 다시 확인해 보세요~',
  'task.lottery.luckyId.error': '당첨 ID 오류:',
  'task.lottery.luckyId.cannotFind': '상품을 찾을 수 없습니다. 당첨 ID는:',
  'task.lottery.interrupt': '아이고, 추첨이 예상치 못하게 중단되었습니다! 나중에 다시 시도하거나 고객 서비스에 문의하세요',
  'task.lottery.start.first': '먼저 시작해 주세요',
  'task.lottery.number.error': '숫자 오류',
  'task.lottery.now': '즉시',
  'task.lottery': '추첨',
  'task.lottery.add': '보충',
  'task.lottery.rewards': '상품 중',
  'task.lottery.draw.congratulate': '축하합니다! 당첨되셨습니다',
  'task.lottery.coin.once': '코인/회',
  'task.lottery.draw.view': '시스템이 배포한 후 수령할 수 있으며, "지 - 교환 기록" 페이지에서 진행 상황을 확인할 수 있습니다.',
  'task.lottery.draw.viewReward': '상품이 귀하의 계정으로 전송되었으며, "복지 - 교환 기록" 페이지에서 확인할 수 있습니다.',
  'task.lottery.draw.physicalGoods': '제때 고객 서비스에 문의하여 수령하고, "QuickFox App - 복지 - 교환 기록" 페이지에서 연락처 및 진행 상황을 확인하세요~',
  'task.lottery.rule': '추첨 규칙',
  'task.lottery.rulePv': '추첨 규칙 클릭 수',
  'task.lottery.myRewardPv': '나의 상품 클릭 수',
  'task.lottery.tab.item1.part1': '이벤트',
  'task.lottery.tab.item1.part2': '규칙',
  'task.lottery.tab.item2.part1': '나의',
  'task.lottery.tab.item2.part2': '상품',
  'task.lottery.coin.earnIt': '코인 벌기>>',
  'task.lottery.more': '추가 추첨',
  'task.lottery.result': '추첨 결과',
  'task.lottery.again': '다시 추첨',
  'task.lottery.toView': '보러 가기',
  'task.lottery.lickDrawNowPv': '"지금 추첨" 버튼 성공 클릭 수',
  'task.lottery.error': '추첨 오류:',
  'task.lottery.notLogin': '로그인하지 않음',
  'task.walfare.center': '복지 센터',
  'task.walfare.info.refresh.done': '개인 정보 새로 고침 완료',
  'task.walfare.info.refresh.error': '개인 정보 새로 고침 오류',
  'task.walfare.refreshed': '새로 고침 완료',
  'task.walfare.refresh.error': '새로 고침 오류',
  'task.walfare.viewPv': '복지 페이지 조회수',
  'task.walfare.all': '전체',
  'task.walfare.giftMoney': '홍바오',
  'task.walfare.coin.clickPv': '골드 코인 상세 클릭 수',
  'task.walfare.coin.left': '남은 골드 코인',
  'task.walfare.coin.mine': '내 골드 코인',
  'task.walfare.coin.expire.thisMonth': '이번 달 만료 코인',
  'task.walfare.coin.expire.time': '만료 시간',
  'task.walfare.coin.earn': '코인 획득',
  'task.walfare.exchange.record': '교환 기록',
  'task.walfare.exchange.recordPv': '교환 기록 클릭 수',
  'task.walfare.coin.descrip': '코인 설명',
  'task.walfare.coin.descrip.usage': '코인은 무엇에 사용되나요?',
  'task.walfare.coin.descrip.usage.part1': '코인은 QuickFox의 가상 화폐 자산으로, 복지 센터에서 현금 상품권, VIP 멤버십 등을 교환할 수 있습니다.',
  'task.walfare.coin.descrip.channel': '코인 얻는 법',
  'task.walfare.coin.descrip.channel.part1': '매일 출석 체크, 친구 초대, QuickFox 공식 계정 팔로우 등의 작업을 완료하여 코인을 획득할 수 있습니다.',
  'task.walfare.coin.descrip.expire': '골드 코인 만료 안내:',
  'task.walfare.coin.descrip.expire.part1': '매월 생성된 코인은 3개월 후에 만료됩니다. 이번 달에 만료될 코인은 만료 코인 목록에 추가되며, 만료 예정 코인이 우선적으로 사용됩니다. 제때 교환하지 않으면 코인이 만료되어 복구할 수 없습니다.',
  'task.walfare.coin.noticePv': '공지 클릭 수',
  'task.walfare.detail.view': '자세히 보기',
  'task.walfare.tasks.more': '추가 작업',
  'task.walfare.tasks.clickPv': '추가 작업 클릭 수',
  'task.goods.clickPv': '상품 클릭 수',
  'welfare.invitev2.page.title': '친구에게 멤버십 선물',
  'welfare.invitev2.page.getFail': '데이터 가져오기 실패',
  'welfare.invitev2.page.directions': '친절한 알림: 무료 선물 할당량을 활성화한 후, 최신 유료 주문은 7일 무조건 환불 자격을 상실합니다.',
  'welfare.invitev2.rule.title': '선물 규칙',
  "welfare.invitev2.rule.content": `
    1、 VIP 특권 사용자는 매월 3회 멤버십 초대권 활성화 가능(구매 이력 필수, 활성화 시 남은 기간 >30일, 자동결제 사용자는 2개월 연속 결제 성공 및 환불/해약 없어야 함). 링크 공유 후 친구가 가입 완료 시 QuickFox 멤버십 수령 가능.<br/> 
    2、매번 증정 인원을 활성화할 때, 당신의 가장 최근 유료 주문은 7일 무이유 환불 자격이 철회됩니다. 해당 규칙에 동의한 후에야 인원을 활성화해주세요.<br/> 
    3、동일한 휴대폰 번호는 15일 회원 자격을 단 한 번만 지급받을 수 있으며, 다시 지급받을 수 없습니다.<br/> 
    4、사용자가 이벤트에 참여하는 과정에서 사용자가 획득한 혜택 권익을 이용해 이익을 창출하거나 불법 수익을 취득하거나, 어떤 형태로든 자신이享有的 혜택 권익을 양도하거나 이전하거나, 본인이 사용하지 않거나, 혹은 QuickFox가 사용자가 권익을 부적절하게 사용할 가능성이 있다는 합리적인 이유를 가지고 의심할 경우 QuickFox는 사용자의 권익 자격을 취소할 수 있으며, 관련 규제 위반 거래를 철회하고 혜택 권익을 되찾을 권리가 있습니다.<br/> 
    5、이 이벤트와 관련된 정보나 도움이 필요한 경우 QuickFox 온라인 고객 센터에 문의해주세요. 이 이벤트는 애플(Apple Inc.)과 무관합니다.<br/> 
    6、법적 범위 내에서 QuickFox는 이번 이벤트에 대해 최종 해석권을 보유합니다.<br/>`,
  'welfare.invitev2.link.title': 'QuickFox 멤버십 카드를 선물합니다',
  'welfare.invitev2.link.descrip': 'QuickFox 귀국 가속기, 중국인 귀국 가속의 첫 번째 선택 브랜드, 한 발 앞서 가속',
  'welfare.invitev2.card.type': 'QuickFox 회원',
  'welfare.invitev2.card.nocheck': '미수령',
  'welfare.invitev2.card.sendTo': '계좌번호 끝 {account} 친구에게 성공적으로 선물했습니다',
  'welfare.invitev2.msgs.title': '친구에게 메시지 남기기',
  'welfare.invitev2.msgs.next': '다른 것으로 변경',
  'welfare.invitev2.btn.allCheck': '모든 멤버십 카드가 친구들에게 수령되었습니다',
  'welfare.invitev2.btn.giftNow': '지금 선물하기',
  'welfare.invitev2.btn.timeEnd': '선물 시간이 종료되었습니다',
  'welfare.invitev2.btn.submitAgain': '선물 계속 요청',
  'welfare.invitev2.btn.upgradeToVip': 'VIP로 업그레이드',
  'welfare.invitev2.btn.leftTime': '남은 선물 시간',
  'welfare.invitev2.btn.copyLink': '공유 링크 복사',
  'welfare.invitev2.btn.copied': '선물 링크 복사됨',
  'welfare.invitev2.modal.cantGift': '현재 멤버십을 선물할 수 없습니다',
  'welfare.invitev2.modal.content':
    '현재 선물 조건이 충족되지 않을 경우, 회원센터에 가셔서 멤버십 시간을 늘리신 후, 친구에게 멤버십을 선물하실 수 있습니다. ',
  'welfare.invitev2.modal.getIt': '기부 규칙',
  'welfare.invitev2.modal.buyVip': '지금 멤버십 구매',
  'task.detail.email.title': '계정 정보 작업 완료',
  'task.detail.email.rule1': '이벤트 규칙',
  'task.detail.email.rule2': '사용자는 이메일 또는 휴대폰 번호를 바인딩하여 보상을 받을 수 있습니다',
  'task.detail.email.rule3': '이번 이벤트 보상은 한 번만 받을 수 있으며 반복해서 받을 수 없습니다',
  'task.detail.email.rule4': '이메일 또는 휴대폰 번호를 바인딩한 사용자는 이 페이지에서 직접 이벤트 보상을 받을 수 있습니다. 이메일 또는 휴대폰 번호로 등록한 사용자는 자동으로 보상을 받게 됩니다',
  'task.detail.email.rule5': '증정 기간은 실시간으로 적립됩니다. 쿠폰 코드는 이메일 또는 SMS로 전송되며 메시지 내의 짧은 URL을 통해서만 참여할 수 있습니다',
  'task.detail.email.btn': '바인딩 및 받기',
  'task.detail.email.received': '받음',
  'task.detail.email.finished': '이벤트가 종료되었습니다',
  'task.detail.email.bind': '지금 바인딩',
  'task.detail.email.bound': '지금 받기',
  'task.detail.email.success': '성공적으로 받음',
  'task.detail.email.failed': '받기 실패',
  'task.detail.email.verify.pleaseEnterCorrectEmail': '올바른 이메일 주소를 입력하세요',
  'task.detail.email.verify.pleaseEnterEmail': '이메일 주소를 입력해 주세요',
  'task.detail.email.verify.pleaseEnterCorrectPhone': '올바른 휴대폰 번호를 입력해 주세요',
  'task.detail.email.verify.pleaseEnterPhone': '휴대폰 번호를 입력해 주세요',
  'task.detail.email.verify.pleaseEnterCorrectVerifyCode': '올바른 인증 코드를 입력해 주세요',
  'task.detail.email.verify.pleaseEnterVerifyCode': '인증 코드를 입력해 주세요',
  'task.detail.email.verify.pleaseEnterDigitPsw': '6-16자리 숫자와 알파벳 조합 비밀번호를 입력해 주세요',
  'task.detail.share.title': '공유 보상',
  'task.detail.share.min5m': '5M 미만의 이미지를 선택하세요',
  'task.detail.share.noPass': '심사 실패, 다시 제출하세요',
  'task.detail.share.submit': '심사 제출',
  'task.detail.share.underReview': '심사 중',
  'task.detail.share.pass': '심사 통과, 보상 지급 완료',
  'task.detail.share.save': '이미지 저장',
  'task.detail.share.cancel': '취소',
  'task.detail.share.noUpload': '먼저 공유 스크린샷을 업로드해 주세요!',
  'task.detail.share.saveSuccess': '이미지가 앨범에 저장되었습니다',
  'task.detail.share.saveFail': '이미지 저장 실패!',
  'task.detail.share.successTip': '검토를 위해 제출되었습니다. 잠시 기다려 주세요',
  'task.detail.share.version': '현재 버전이 낮습니다. "내 정보 - 내 계정" 페이지로 이동하여 바인딩을 완료하세요',
  'task.detail.share.message': '이미지를 업로드해 주세요!',
};
// 邀请裂变第4期
const pointEventV4 = {
  'V4.welfare.center.title': '복지 센터',
  'V4.welfare.center.more': '더 많은 혜택',
  'V4.welfare.foreignStudent.title': '유학생 전용 혜택',
  'V4.welfare.foreignRule.title': '규칙 설명',
  'V4.welfare.redeem.norecord.goForIt': '아직 기록이 없어요, 빨리 혜택을 받으러 가세요~',

  'V4.welfare.record.title': '혜택 기록',
  'V4.welfare.miniGame.title': '미니게임 임무',

  'V4.welfare.tasks.invite': '친구 초대',
  'V4.welfare.tasks.wx': '공식 계정 팔로우',
  'V4.welfare.tasks.email': '전화번호/이메일 주소 연결',
  'V4.welfare.tasks.sign': '매일 체크인',
  'V4.welfare.tasks.exchange': '코인 사용',

  'V4.welfare.tasks.invite.desc': '친구를 초대하여 구매 시간의 10%를 받으세요',
  'V4.welfare.tasks.wx.desc': 'QuickFox 팔로우하고 2시간 VIP 혜택 받기',
  'V4.welfare.tasks.email.desc': '계정을 2시간 VIP 혜택으로 연결',
  'V4.welfare.tasks.sign.desc': '계속되는 체크인으로 VIP 시간 획득',
  'V4.welfare.tasks.exchange.desc': '일회성 코인 사용',

  'V4.welfare.tasks.invite.btn': '가다',
  'V4.welfare.tasks.sign.btn': '가다',
  'V4.welfare.tasks.exchange.btn': '가다',
  'V4.welfare.tasks.hot': '인기 태스크',
  'V4.welfare.tasks.completed': '가다',
  'V4.welfare.tasks.goForIt': '가다 가기',
  'V4.welfare.tasks.exchanged': '가다',
  'V4.welfare.tasks.goExchange': '가다',

  'V4.welfare.intlAuth.title': '유학생 인증',
  'V4.welfare.intlAuth.desc': '국제학생증 취득 후, 복지센터에서 국제학생을 위한 특별 혜택을 누릴 수 있습니다',
  'V4.welfare.intlAuth.btn': '유학생 혜택 받기',
  'V4.welfare.intlAuth.know': '확인',
  'V4.welfare.intlAuth.goForItBtn': '즉시 인증',

  'V4.welfare.vip.title': 'VIP 특권',
  'V4.welfare.vip.desc': 'QuickFoxVIP 멤버십을 구매하고 멤버십이 만료되지 않은 모든 사용자는 VIP 특권을 누리게 됩니다. 복지 센터에서 VIP 특별 혜택을 받으실 수 있습니다',
  'V4.welfare.vip.btn': 'VIP 기간 연장',
  'V4.welfare.vip.know': '확인',
  'V4.welfare.vip.upgrade': '즉시 업그레이드',

  'V4.welfare.receive.record': '수령 기록',

  'V4.welfare.btn.receive': '받기',
  'V4.welfare.btn.received': '받음',
  'V4.welfare.btn.nextMonth': '{month}월 수령',

  'V4.welfare.btn.monthWelfare': '{month}월 혜택',

  'V4.welfare.empty.noData': '데이터 없음',
  'V4.welfare.btn.moreWelfare': '더 많은 혜택 >',

  // 福利详情页
  'V4.welfare.detail.title': '혜택 상세',
  'V4.welfare.detail.myRight': '내 혜택',
  'V4.welfare.detail.welfareDesc': '혜택 설명',
  'V4.welfare.detail.upgradeToVip': 'VIP 업그레이드',
  'V4.welfare.detail.upgradeToVip.btn': '즉시 업그레이드',
  'V4.welfare.detail.received': '클레임 완료 - 기록에서 확인',
  'V4.welfare.detail.nextMonth': '{month}월에 받기',
  'V4.welfare.detail.complete': '유학생 인증 완료',

  'V4.welfare.detail.received.success': 'VIP 특권 적립 완료. 혜택 기록에서 확인',
  'V4.welfare.detail.received.goForIt': '바로 가기',
  'V4.welfare.detail.received.success.tip1': '수령 성공! 할인 상품 구매 →',
  'V4.welfare.detail.received.success.tip2': '내 정보 페이지에서도 확인 가능~',
  'V4.welfare.detail.received.success.btn': '즉시 구매',
  'V4.welfare.detail.received.success.tip3': '상품 코드: {key}\n혜택 기록에서 확인',
  'V4.welfare.detail.received.success.tip4': 'Tip: 인증 메일 링크로 바로 구매',

  'V4.welfare.detail.received.success.tip5': '안내',
  'V4.welfare.detail.received.success.tip6': '{goodsName} 혜택 상품은 VIP 유효기간이 {remainingTimeDaysMore}일 이상 필요합니다. 현재 수령 조건을 만족하지 않습니다. 회원을 구매한 후 수령하시겠습니까?',
  'V4.welfare.detail.received.success.btn2': 'VIP 구매',
  'V4.welfare.detail.received.success.title': '수령 성공',
  'V4.welfare.detail.received.success.tip7': '일반 사용자로서 {이번 달} 동안 매달 혜택을 받으실 수 있습니다. VIP로 업그레이드하시면 더 높은 등급의 혜택을 받으실 수 있습니다. 업그레이드가 필요하신가요?',
  'V4.welfare.detail.received.success.btn3': 'VIP 업그레이드',
  'V4.welfare.detail.received.failed': '수령 실패',
  'V4.welfare.detail.received.success.btn4': '베이직으로 계속',
  'V4.welfare.detail.received.success.tip8': '수령 완료. 수령 기록에서 확인해 주세요',
  // 暂停管理页
  'V4.welfare.pause.title': '일시정지 관리',
  'V4.welfare.pause.rule': '규칙 설명',
  'V4.welfare.pause.rule.title': '일시정지 규칙',
  'V4.welfare.pause.rule.know': '확인',
  'V4.welfare.pause.resume': '청구 재개',
  'V4.welfare.pause.pause': '일시정지 청구',
  'V4.welfare.pause.resume.tip': '일시정지 청구 취소 시 일시정지 청구 시간이 반환되지 않습니다. 계속 복구하시겠습니까?',
  'V4.welfare.pause.resume.cancel': '취소',
  'V4.welfare.pause.resume.confirm': '확인',

  'V4.welfare.pause.select': '일시정지 시간 선택',
  'V4.welfare.pause.failed': '일시정지 실패',

  'V4.welfare.pause.record': '기록',

  'V4.welfare.pause.thisYear': '올해',
  'V4.welfare.pause.remainCount': '일시정지 가능 횟수',
  'V4.welfare.pause.count': '횟수',
  'V4.welfare.pause.remainMon': '일시정지 가능 총 시간',
  'V4.welfare.pause.month': '개월',

  'V4.welfare.pause.myRight': '내 권리',
  'V4.welfare.pause.expiredTip': 'VIP가 만료되어 일시 중지할 수 없습니다. 어서 해봐요',
  'V4.welfare.pause.buyGuide': '멤버십 충전',
  'V4.welfare.pause.buyGuide.tip': '그래~',
  'V4.welfare.pause.usedTip': '연간 일시 중지 시간 또는 기간을 모두 사용했으며 다시 일시 중지할 수 없습니다. ',

  'V4.welfare.pause.currentStatus': '현재 회원 상태',
  'V4.welfare.pause.status.pause': '청구가 일시 중지되었습니다',
  'V4.welfare.pause.tatus.normal': '정상 청구',

  'V4.welfare.pause.pauseTimeType.minute': '분',
  'V4.welfare.pause.pauseTimeType.hour': '시간',
  'V4.welfare.pause.pauseTimeType.day': '요일',
  'V4.welfare.pause.expired': 'VIP가 만료되었습니다',
  'V4.welfare.pause.pauseTime': '일시 정지가 시작됩니다',
  'V4.welfare.pause.resumeTime': '청구 재개 시간',
  'V4.welfare.pause.selectTip': '청구 일시중지 기간 선택',
  'V4.welfare.pause.selectPlaceholder': '선택되지 않음',

  'V4.welfare.pause.record.submitTime': '제출 시간:',
  'V4.welfare.pause.record.type': '작업 유형:',
  'V4.welfare.pause.record.usedTime': '사용된 일시 중지 시간:',
  'V4.welfare.pause.record.remainTime': '남은 일시 중지 시간:',
  'V4.welfare.pause.record.pause': '청구 일시 중지',
  'V4.welfare.pause.record.resume': '수동 재개',
  'V4.welfare.pause.record.month': '월',

  // 留学生认证页
  'V4.welfare.intlAuth.notLogin': '아직 로그인하지 않았습니다',
  'V4.welfare.intlAuth.completed': '국제학생인증을 완료하였습니다',
  'V4.welfare.intlAuth.goForIt': '국제학생증 발급을 즉시 완료하세요',
  'V4.welfare.intlAuth.pause': '멤버십 일시 정지',
  'V4.welfare.intlAuth.pause.desc': '연말연시 결제 일시 정지',
  'V4.welfare.intlAuth.vip.title': '7일 VIP',
  'V4.welfare.intlAuth.vip.desc': '첫 인증 후',
  'V4.welfare.intlAuth.discount.title': '연간 10% 할인',
  'V4.welfare.intlAuth.discount.desc': '매달 10% 할인 쿠폰을 받으세요',
  'V4.welfare.intlAuth.invite.title': '+5% 친구 보너스',
  'V4.welfare.intlAuth.invite.desc': '추가 시간 리워드',
  'V4.welfare.intlAuth.coupon.title': 'Gonest 50￥ 배송 쿠폰',
  'V4.welfare.intlAuth.coupon.desc': '3개의 특별 쿠폰',
  'V4.welfare.intlAuth.contact.title': 'WeChat 계정으로 혜택을 받으세요',
  'V4.welfare.intlAuth.contact.desc': '다양한 선물',
  'V4.welfare.intlAuth.contact.btn': '받기',
  'V4.welfare.intlAuth.received': '받기',
  'V4.welfare.intlAuth.receive': '받기',
  'V4.welfare.intlAuth.welfare.title': '인증 후 특별 혜택',
  'V4.welfare.intlAuth.pause.btn': '받기',
  'V4.welfare.intlAuth.receive.btn': '받기',
  'V4.welfare.intlAuth.invite.btn': '받기',
  'V4.welfare.intlAuth.email.error': '이메일 형식이 잘못되었습니다!',
  'V4.welfare.intlAuth.desc.tip': '다음 정보는 유학생의 신원 확인에만 사용되며 로그인이나 비밀번호로 사용되지 않습니다. 홍콩, 마카오, 대만 유학생을 포함한 유학생만 신청 가능하며, 학생의 학력 관련 이메일 주소는 정확하고 확인 가능합니다.',
  'V4.welfare.intlAuth.auth.btn': '인증',
  'V4.welfare.intlAuth.email.placeholder': '학교 교육 이메일',
  'V4.welfare.intlAuth.verifyCode.placeholder': '이메일 확인 코드',
  'V4.welfare.intlAuth.email.error.tip': '이메일 주소가 인증되지 않으면 광고 이메일에 의해 가로채기되었는지 확인할 수 있습니다. 더 자세한 내용은 여기를 클릭하세요 ',
  'V4.welfare.intlAuth.email.error.tip.link': '고객 서비스에 문의하세요',

  'V4.welfare.intlAuth.getCode': '인증 코드 받기',
  'V4.welfare.intlAuth.getCode.error': '인증 코드를 얻지 못했습니다',
  'V4.welfare.intlAuth.getCode.success': '인증번호가 전송되었습니다. 확인해 주세요',
  'V4.welfare.intlAuth.certification.success': '인증 성공',
  'V4.welfare.intlAuth.certification.error': '인증에 실패했습니다',
  'V4.welfare.intlAuth.getCertificateInfo.error': '데이터를 가져오지 못했습니다',
  'V4.welfare.intlAuth.getWelfare.success': '7일 VIP 기간이 성공적으로 수신되었습니다',
  'V4.welfare.intlAuth.getWelfare.error': '수집에 실패했습니다',
  'V4.welfare.intlAuth.getCode.reGet': '다시 획득',
  'V4.welfare.foreignRule.getCertificateInfo.error': '데이터를 가져오지 못했습니다',
}
const cancel = {
  'cancel.title.reminder': '계정 삭제 알림',
  'cancel.title.auth': '신원 확인',
  'cancel.reminder.artical': `
<div  style="color: #90A1DC; ">
     계정을 삭제하는 것은 되돌릴 수 없는 조치입니다. 다음 중요 안내 사항을认认真하게 읽어주세요:
   </div>
   <p>
     1. 계정을 삭제하기 전에 모든 결제 플랫폼의 연속 월정액 서비스를 해지했는지 확인해주세요. 해당 <a href="{url}">해지 가이드</a>를 확인하여 해지를 완료할 수 있습니다. 귀하의 권익을 보호하기 위해 해지하지 않으면 계정 삭제를 완료할 수 없습니다.
   </p>
   <p>
     2. 계정 삭제 신청부터 계정 삭제가 완료되기까지 15일의 대기 기간이 있습니다. 대기 기간 동안 언제든지 계정 삭제를 중단할 수 있습니다. 대기 기간이 종료되면 계정이 삭제됩니다.
   </p>
   <p>
    3. 계정이 삭제되면 모든 계정 데이터가 삭제됩니다. 삭제된 계정은 로그인할 수 없으며 복구할 수 없습니다. 잔여 회원 기간, 골드 코인 잔액 등을 포함한 모든 권익도 삭제되어 복구할 수 없습니다.
   </p>
   <p>
     4. 계정이 삭제되면 해당 계정과 연결된 휴대폰 번호, 이메일 주소 및 제3자 로그인 정보가 해제됩니다. 로그인 정보는 해제된 후 다른 계정에 대해 등록하거나 연결할 수 있습니다.
   </p>
    <p>
     5. 이미 삭제된 계정을 다시 등록할 경우 이전에 받았던 신규 사용자 혜택, 신규 사용자 슈퍼 VIP 기간 증정, 초대 이벤트 골드 코인 보상 등을 받을 수 없습니다.
   </p>
`,
  'cancel.reminder.agree': '읽고 동의함: QuickFox',
  'cancel.reminder.agreement': '계정 해지 약관',
  'cancel.reminder.next': '다음',
  'cancel.reminder.read': '위의 알림을 주의 깊게 읽어주세요',
  'cancel.reminder.cancelSign': '현재 {signTypeText} 월정액 서비스가 해지되지 않았습니다. 해지 완료 후 계정 삭제를 진행해주세요.',
  'cancel.auth.input': '현재 계정 비밀번호를 입력하여 인증을 완료하세요',
  'cancel.auth.confirm': '해지 확인',
  'cancel.auth.tips': '취소 요청을 제출한 후 15일의 대기 기간이 있습니다. 이 기간 동안 언제든지 다시 로그인하여 취소를 종료할 수 있습니다.',
  'cancel.auth.pwd': '비밀번호를 입력하세요',
  'cancel.auth.relogin.third': '인증을 완료하려면 제3자 계정으로 다시 로그인하세요.',
  'cancel.auth.relogin': '다시 로그인',
  'cancel.auth.please': '부탁합니다',
  'cancel.auth.finish': '인증 완료',
  'cancel.auth.unDetected': '제3자 계정이 감지되지 않았습니다. 고객 서비스에 문의해 주세요',
  'cancel.auth.inconsistent': '로그인한 제3자 계정이 현재 바인딩된 계정과 일치하지 않습니다. 다시 시도해 주세요',
  'cancel.auth.failed': '제3자 계정 확인 실패',
  'cancel.auth.failed.accident': '확인 실패',
  'cancel.wx.pay': '자동 갱신 관리',
  'cancel.tips.userInfoFailed': '사용자 정보를 가져오지 못했습니다. 나중에 다시 시도해 주세요',
  'cancel.tips.unexpectedError': '예상치 못한 오류가 발생했습니다',
  'cancel.tips.failToCheckSignStatus': '계약 상태 조회 실패',
};
const memberi = {
  'memberi.title': '멤버십 교환',
  'memberi.valicode': '교환 코드를 입력하세요',
  'memberi.loginTip': '로그인 후 교환할 수 있습니다',
  'memberi.loginBtn': '로그인/회원가입',
  'memberi.placeholder': '교환코드를 입력해주세요',
  'memberi.getcode': '지금 교환하기',
  'memberi.descTitle': '교환 규칙',
  'memberi.desc1': '환불 코드는 QuickFox 전용 혜택 상품입니다. 환불 코드를 판매하거나 상업적 행위를 하지 마십시오. 위반 시 QuickFox는 회원 기간을 회수할 권리를 보유합니다.',
  'memberi.desc2': '교환 성공 시 해당 VIP 기간을 받을 수 있습니다.',
  'memberi.desc3': 'VIP 회원 기간을 이미 보유한 사용자 및 계약 상태에 있는 사용자는 교환 성공 후 VIP 기간이 연장됩니다.',
  'memberi.desc4': 'QuickFox는 법률이 정한 범위 내에서 본 규칙의 해석권을 가집니다. 궁금한 점이 있으면 온라인 고객 서비스에 문의하세요.',
  'memberi.success': '교환 성공',
  'memberi.fail': '교환 실패',
  'memberi.success1': '획득함',
  'memberi.ok': '알겠습니다',
  'memberi.blacklistTips': '현재 계정에 위험이 있어 교환 코드를 사용할 수 없습니다.',
};
const customizedMembership = {
  'customizedMembership.viptimer': '남은 시간',
  'customizedMembership.concat': '고객 서비스에 문의하여 독점 맞춤 경로를 받으세요',
  'customizedMembership.desc1': '독점 대역폭 보장',
  'customizedMembership.desc2': '4K 영상 즉시 재생',
  'customizedMembership.desc3': '원활한 스트리밍',
  'customizedMembership.desc4': '이중 라인으로 더블 안정성',
  'customizedMembership.desc5': '세 기기 동시 접속',
  'customizedMembership.desc6': '모든 클라이언트 지원',
  'customizedMembership.btn': '갱신 상담',
  'customizedMembership.btn1': '구매 상담',
  'customizedMembership.title': '맞춤형 멤버십',
};
const sportsQuiz = {
  'sportsQuiz.title': '이벤트 상세 정보',
  'sportsQuiz.shareAndGetCoins': '빠른 공유로 코인 획득',
  'sportsQuiz.how2play': '게임 소개',
  'sportsQuiz.rule': '월드컵 이벤트 규칙',
  'sportsQuiz.guessed': '당신은 추측했습니다',
  'sportsQuiz.advance': '진급',
  'sportsQuiz.win': '승리',
  'sportsQuiz.draw': '무승부',
  'sportsQuiz.guessWithCoins': '{coins} 코인으로 추측하기',
  'sportsQuiz.ifGuessRight': '정확히 맞추면 획득',
  'sportsQuiz.includes': '경기 결과는 연장전과 승부차기 포함',
  'sportsQuiz.leftTime': '남은 추측 시간',
  'sportsQuiz.leftQuota': '남은 참여 자리',
  'sportsQuiz.end': '이 경기 예측이 종료되었습니다',
  'sportsQuiz.others': '다른 경기를 팔로우해 주세요~',
  'sportsQuiz.getFromNotice': '(메시지 센터를 통해 수령)',
  'sportsQuiz.youHaveGuessed': '예측에 참여하셨습니다',
  'sportsQuiz.ifThen': '만약 {predict}{result} 당신은 얻을 수 있습니다 ',
  'sportsQuiz.guessedRight': '정확한 예측을 축하합니다, 당신의 ',
  'sportsQuiz.goGet': '발송되었습니다. 메시지 센터에서 받아가세요~',
  'sportsQuiz.yourGuess': '당신의 추측은:',
  'sportsQuiz.guessedWrong': '추측이 틀렸어요, 다음에 다시 도전하세요~',
  'sportsQuiz.goGetCoins': '코인을 벌어보세요',
  'sportsQuiz.platforms': '다음 라이브 플랫폼에서 관전하실 수 있습니다',
  'sportsQuiz.useQF': 'Quickfox 비디오 모드를 사용하여 저작권 제한을 한 번에 해제하세요',
  'sportsQuiz.cctv': 'CCTV 비디오',
  'sportsQuiz.yangshipin': 'CCTV 비디오',
  'sportsQuiz.migu': '미구 비디오',
  'sportsQuiz.tiktok': '틱톡',
};
const device = {
  'device.title': '로그인된 장치',
  'device.dialog.title': '로그아웃',
  'device.dialog.centent': '로그아웃 후 이 기기에서 다시 로그인하려면 계정 확인이 필요합니다. 로그아웃하시겠습니까?',
  'device.dialog.ok': '확인',
  'device.dialog.cancel': '취소',
  'applyRecord.title': '신청 기록',
  'applyRecord.exitFailed': '거부됨',
  'applyRecord.using': '출시됨',
  'applyRecord.waiting': '대기 중',
  'device.thisDevice': '이 기기',
  'device.exit': '나가기',
  'device.offline': '오프라인',
  'device.exitSuccess': '성공적으로 나가기',
};
// 绑定邮箱活动
const bindEmail = {
  'bindEmail.title': '이메일 바인딩',
  'bindEmail.success.tip': '이메일/휴대폰 번호가 성공적으로 연결되었습니다!',
  'bindEmail.areaCode': '지역 코드',
  'bindEmail.phoneEmpty': '전화 번호',
  'bindEmail.emailEmpty': '이메일 주소',
  'bindEmail.switchTo': '',
  'bindEmail.getCode': '인증 코드',
  'bindEmail.findCountry': '국가 또는 지역 코드',
  'bindEmail.emailVerify': '올바른 이메일 주소를 입력하세요',
  'bindEmail.phoneVerify': '올바른 휴대폰 번호를 입력하세요',
  'bindEmail.codeVerify': '올바른 인증 코드를 입력하세요',
  'bindEmail.pwsVerify': '6-16자리 숫자와 문자 조합 비밀번호',
  'bindEmail.pwsEmpty': '비밀번호를 입력하세요',
  'bindEmail.codeEmpty': '인증번호를 입력해주세요',
  'bindEmail.phone': '휴대폰',
  'bindEmail.email': '이메일',
};
// 任务补充
const taskSupplement = {
  'taskSupplement.redemptionDetails': '교환 상세 페이지',
  'taskSupplement.missionRules': '작업 규칙',
  'taskSupplement.shareScreenshot': '공유 스크린샷 선택',
  'taskSupplement.supportChannel': '현재 샤오홍슈, 위챗, 웨이보, 더우인 등의 플랫폼에서 공유 스크린샷을 지원합니다.',
  'taskSupplement.advisoryService': '작업 규칙을 준수해 주세요. 궁금한 점이 있으면 고객 서비스에 문의하세요.',
  'taskSupplement.auditPrompt1': '검토 기간 동안 공유 내용을 볼 수 있도록 유지하세요.',
  'taskSupplement.auditPrompt2': '승인 후 100골드 코인이 자동으로 지급됩니다. 기다려 주세요.',
  'taskSupplement.sharePoster': '포스터 공유',
  'taskSupplement.saveImg': '이미지를 길게 눌러 저장',
  'taskSupplement.rulesDesc4': '지금부터 모든 등록 사용자는 작업 페이지에서 소셜 플랫폼(샤오홍슈, 위챗, 웨이보, Douyin, Facebook, Twitter, Instagram, Tiktok 등 포함)에 QuickFox 공유 포스터가 포함된 스크린샷을 업로드할 수 있습니다. 승인 후 100골드 코인을 보상으로 받을 수 있습니다.',
  'taskSupplement.rulesDesc5': '각 사용자는 하나의 작업을 완료할 수 있습니다. 검토 중에는 소셜 플랫폼에서 콘텐츠가 표시되도록 유지하세요. 그렇지 않으면 거절될 수 있습니다.',
  'taskSupplement.rulesDesc6': '2일 내 심사 완료',
  'taskSupplement.rulesDesc7': '마케팅 활동 중 사용자가 혜택을 이용해 이익을 얻거나 불법적으로 이득을 취하거나, 혜택을 양도하거나 오용하는 경우, QuickFox는 혜택을 취소하고 거래를 철회할 수 있습니다.',
  'taskSupplement.rulesDesc8': '이벤트 관련 정보 및 도움이 필요하면 QuickFox 온라인 고객센터에 문의하세요. Apple Inc.과 무관합니다.',
  'taskSupplement.rulesDesc9': 'QuickFox는 법적 범위 내에서 이벤트의 최종 해석권을 보유합니다.',
  'taskSupplement.xiecheng': '트립 랜딩 페이지',
};
// 微信续费补充
const wxPayManage = {
  'wxPayManage.activatedBusiness': '활성화된 서비스',
  'wxPayManage.weChatPay': '위챗페이',
  'wxPayManage.continuousMonthlyMembership': '월간 구독 회원',
  'wxPayManage.nextRenewalTime': '다음 자동 결제 시간',
  'wxPayManage.stopService': '서비스 종료',
  'wxPayManage.successfullyUnsubscribe': '위챗 월간 구독 취소 성공',
};
// 支付宝实名认证
const zfbManage = {
  'zfbManage.cancelledVerification': '사용자 확인 취소',
  'zfbManage.enterNumber': '올바른 18자리 주민등록번호를 입력하세요',
  'zfbManage.enterX': '주민등록번호 끝에 문자가 포함된 경우 입력하세요',
  'zfbManage.enterID': '주민등록증에 등록된 주민등록번호를 입력하세요',
  'zfbManage.enterName': '주민등록증에 등록된 실명을 입력하세요',
  'zfbManage.verificationFailed': '신분증 정보 검증 실패',
  'zfbManage.getCode': '클라이언트로 돌아가 QR 코드를 다시 받으세요',
  'zfbManage.realNameverify': '신원 확인',
  'zfbManage.successed': '신원 확인을 완료하신 것을 축하드립니다',
  'zfbManage.complete': '완료',
  'zfbManage.callChatTextPrefix': '중화인민공화국 거주자가 아닌 사용자는',
  'zfbManage.callChatText': '고객 서비스 문의',
  'zfbManage.callChatTextSuffix': '검증 완료',
  'zfbManage.authentication': '신원 확인 사용 약관',
  'zfbManage.realNameVerifyDesc1': '계정 보안을 위해 신원 확인을 완료해 주세요.',
  'zfbManage.realNameVerifyDesc2': '현재 신원 확인 서비스는 "알리페이"에서 제공합니다. 관련 앱을 미리 설치하고 인증해 주세요.',
  'zfbManage.realNameVerifyDesc3': '제출하신 신원 정보는 신원 확인 용도로만 사용되며, QuickFox는 이를 다른 어떤 시나리오에도 적용하지 않으며 제3자에게 공개하지 않을 것을 약속합니다.',
  'zfbManage.qRealNameverify': 'QuickFox 신원 확인',
  'zfbManage.enterRealName': '신분증에 기재된 실명을 입력해주세요',
  'zfbManage.realName': '실명',
  'zfbManage.enterRealID': '18자리 신분증 번호를 입력해주세요',
  'zfbManage.IDCode': '신분증 번호',
  'zfbManage.now': '즉시 확인',
  'zfbManage.go': '인증 중으로 이동',
  'zfbManage.upgrade': '현재 클라이언트는 이 인터페이스를 지원하지 않습니다. 업그레이드하세요.',
  'zfbManage.failed': '로드 실패',
  'zfbManage.sendData': '전송된 데이터 복호화',
};
const blacklistBlocking = {
  'blacklist.youRisk': '귀하의 계정에 위험이 있습니다',
  'blacklist.cannot': '일시적으로 복지 센터 작업에 참여할 수 없습니다',
  'blacklist.sendEmail': '이의가 있으시면 info@quickfox.com.cn으로 이메일을 보내주세요',
  'vip.cantuse': '기업 서브 계정은 이 작업을 수행할 수 없습니다',
};
const FraudBlacklistBlocking = {
  'blacklist.policy': '정책상의 이유로',
  'blacklist.policyDetail': '귀하의 국가 또는 지역은 더 이상 서비스를 제공하지 않습니다',
  'blacklist.thanks': '이해와 지원에 감사드립니다'
};

const weeklyReward = {
  'weeklyReward.title': '주간 혜택',
  'weeklyReward.award': '{vipTime}{timeType} VIP 부스트',
  'weeklyReward.award.desc': 'VIP 전용 서비스 제공',
  'weeklyReward.addNow': '추가하기',
  'weeklyReward.cancel': '취소',
  'weeklyReward.confirm': '확인',
  'weeklyReward.rule': '규정',
  'weeklyReward.rule.desc': '1:1 VIP 서비스 제공',
  'weeklyReward.remainingCount': '추첨 기회 소진',
  'weeklyReward.immediately': '즉시',
  'weeklyReward.lottery': '추첨',
  'weeklyReward.lotteryCount': '{count}번의 기회',
  'weeklyReward.thanks': '중장이 아니다',
  'weeklyReward.record': '기록',
  'weeklyReward.lotteryFailed': '추첨 실패',
  'weeklyReward.activityExpired': '이벤트 만료',
  'weeklyReward.activityEnded': '이벤트 종료',
  'weeklyReward.soonStart': '미시작',
  'weeklyReward.startLater': '{time} 시작',
  'weeklyReward.stock': '재고 {count}%',
  'weeklyReward.notStart': '이 세션은 아직 시작되지 않았습니다',
  'weeklyReward.ended': '이 세션은 종료되었습니다',
  'weeklyReward.noActivity': '진행 중인 이벤트 없음',
  'weeklyReward.record.title': '주간 혜택',
  'weeklyReward.record.time': '{timeStr} VIP 기간',
  'weeklyReward.rule.title': '이벤트 규정',
};

const zh_CN = {
  ...about,
  ...contact,
  ...help,
  ...helpDetail,
  ...http,
  ...notice,
  ...tsupport,
  ...Welfare,
  ...PageTitle,
  ...Common,
  ...Tips,
  ...ActivationRecord,
  ...TimeType,
  ...tutorial,
  ...pointEventEnd,
  ...taskCenterV3,
  ...pointEventV4,
  ...cancel,
  ...memberi,
  ...sportsQuiz,
  ...device,
  ...customizedMembership,
  ...bindEmail,
  ...taskSupplement,
  ...wxPayManage,
  ...zfbManage,
  ...blacklistBlocking,
  ...FraudBlacklistBlocking,
  ...weeklyReward,
};

export default zh_CN;